import { render } from "./company.vue?vue&type=template&id=1b5a49b6"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=1b5a49b6&lang=css"
script.render = render

export default script